import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { OperationDetailsLocationSelectPage } from './operation-details-location-select';
import { TransitPreviewComponent } from '../../shared/components/transit-preview/transit-preview';
import { PipesModule } from '../../../pipes/pipes.module';
import { TransitPreviewOperationListComponent } from '../../shared/components/transit-preview/transit-preview-operation-list/transit-preview-operation-list';
import { DirectivesModule } from '../../../directives/directives.module';
import { IonicSelectableModule } from 'ionic-selectable';

@NgModule({
  declarations: [
    OperationDetailsLocationSelectPage,
    TransitPreviewComponent,
    TransitPreviewOperationListComponent
  ],
    imports: [
        IonicPageModule.forChild(OperationDetailsLocationSelectPage),
        PipesModule,
        DirectivesModule,
        IonicSelectableModule,
    ],
  exports: [
    TransitPreviewComponent,
    TransitPreviewOperationListComponent
  ]
})
export class OperationDetailsLocationSelectPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/operations/operation-details-location-select/operation-details-location-select.module.ts